import {
  Button,
  Flex,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BlueButton } from "~/routes/_shared/Buttons";
import { useCreateCourseMutation } from "./index.generated";

export const CreateCourseButton = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [createCourseRes, createCourse] = useCreateCourseMutation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [courseName, setCourseName] = useState("");

  useEffect(() => {
    if (createCourseRes.data) {
      toast({
        title: "コースを作成しました。",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      const courseId = createCourseRes.data.createCourse.id;
      if (courseId) {
        navigate(`/courses/${courseId}`);
      }
    }
  }, [createCourseRes.data]);
  return (
    <>
      <BlueButton onClick={onOpen} label={"新規コース作成"} />
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>コースの作成</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text pb={2}>コース名を入力してください。</Text>
            <Input
              placeholder="コース名"
              onChange={(event) => {
                setCourseName(event.target.value);
              }}
            ></Input>
          </ModalBody>

          <ModalFooter>
            <Flex>
              <BlueButton
                onClick={() => {
                  if (courseName.replaceAll(" ", "") === "") {
                    toast({
                      title: "コース名を入力してください。",
                      status: "error",
                      duration: 5000,
                      isClosable: true,
                    });
                  } else {
                    createCourse({ input: { name: courseName } });
                    onClose();
                  }
                }}
                label={"コースを作成"}
              />
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
